import LocalizedStrings from "react-localization";

export const actionButtonsStrings = new LocalizedStrings({
  en: { paperClip: "Paper clip", reject: "Reject", validate: "Validate" },
  fr: { paperClip: "Trombone", reject: "Rejeter", validate: "Valider" },
});
